import React from 'react';

import Select from 'react-select';

import shipOperatorType from '@/data/shipOperatorType';
import { getCustomStyles } from '@/utils/customStyleSelect';

const SelectTypeShipOperator: React.FC<any> = ({ name, value, defaultValue, placeholder, handleChange, hasError, isDisabled }) => {
    return (
        <Select
            name={name}
            value={shipOperatorType.find((option: any) => option.value === value)}
            onChange={handleChange}
            options={shipOperatorType}
            defaultValue={defaultValue}
            placeholder={placeholder}
            styles={getCustomStyles(hasError)}
            isDisabled={isDisabled}
        />
    );
};

export default SelectTypeShipOperator;
